const locations = [
  {
    title: 'Lagos State',
    locations: [
      'Ikeja',
      'Agege',
      'Shomolu',
      'Ajah',
      'Sangotedo',
      'Lekki',
      'Marryland',
      'Ijaye',
    ],
  },
  {
    title: 'Ogun State',
    locations: [
      'Ikeja',
      'Agege',
      'Shomolu',
      'Ajah',
      'Sangotedo',
      'Lekki',
      'Marryland',
      'Ijaye',
    ],
  },
  {
    title: 'Abuja State',
    locations: [
      'Ikeja',
      'Agege',
      'Shomolu',
      'Ajah',
      'Sangotedo',
      'Lekki',
      'Marryland',
      'Ijaye',
    ],
  },
  {
    title: 'Oyo State',
    locations: [
      'Ikeja',
      'Agege',
      'Shomolu',
      'Ajah',
      'Sangotedo',
      'Lekki',
      'Marryland',
      'Ijaye',
    ],
  },
]

export default locations
